const Stats = () => {

    // Wait for the DOM to be fully loaded
    document.addEventListener('DOMContentLoaded', function () {
        const statsIcon = document.querySelector('.header__icon--stats');
        const stats = document.getElementById('stats');
        const closeStatsBtn = document.getElementById('closeStatsBtn');
        const overlay = document.getElementById('overlay');

        // Function to open the popup
        function openStats() {
            stats.classList.add('active');
            overlay.classList.add('active');
        }

        // Function to close the popup
        function closeStats() {
            stats.classList.remove('active');
            overlay.classList.remove('active');
        }

        // Event listener to open when icon is clicked
        statsIcon.addEventListener('click', openStats);

        // Event listener to close when close button is clicked
        closeStatsBtn.addEventListener('click', closeStats);

        // Close when pressing the Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && stats.classList.contains('active')) {
                closeStats();
            }
        });
    });
}

export default Stats;
